<template>
  <!-- <WebCamera /> -->
  <router-view/>
</template>

<script>
import 'normalize.css';
import { useStore } from 'vuex';
// import webCameraPlayer from '@/composables/webCameraPlayer';
// import WebCamera from '@/components/WebCamera.vue';

export default {
  name: 'App',
  components: {
    // WebCamera
  },
  setup() {
    const store = useStore();
    const initialized = () => {
      // console.log('initialized');
      store.commit('initialized');
    }
    initialized();
    // const { initWebCamera } = webCameraPlayer();
    // initWebCamera();
    
  },
}
</script>

<style lang="scss">
#app {
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  text-align: center;
  width: 100%;
  height: 100%;
  line-height: 1.6;
}

* {
  box-sizing: border-box;
}

a {
  color: #000;
  text-decoration: none;
}

ul {
  list-style-type: none;
  margin-block: 0;
  padding-inline: 0;
}

img {
  width: 100%;
  height: auto;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes overlay-fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes y-easeOutElastic {
	0% {
		transform: translateY(0% - 100%);
	}

	16% {
		transform: translateY(132.27% - 100%);
	}

	28% {
		transform: translateY(86.88% - 100%);
	}

	44% {
		transform: translateY(104.63% - 100%);
	}

	59% {
		transform: translateY(98.36% - 100%);
	}

	73% {
		transform: translateY(100.58% - 100%);
	}

	88% {
		transform: translateY(99.8% - 100%);
	}

	100% {
		transform: translateY(100% - 100%);
	}

}
</style>
